import { api, setConfig } from '../..';
import { mapEntityToApi, mapApiToEntity } from './mapper';
import { PropertyType } from '../../../common';

export const getCasinoGames = (data: PropertyType): Promise<PropertyType> =>
	api.post(`games${data?.query}`, mapEntityToApi(data), setConfig(data)).then((res) => {
		return mapApiToEntity(res.data);
	});

export const getCasinoGamesExport = (data: PropertyType): Promise<PropertyType> =>
	api.post(`export/games${data?.query}`, { sid: data.token }, setConfig(data)).then((res) => {
		return mapApiToEntity(res.data);
	});
